import { render, staticRenderFns } from "./contenido.vue?vue&type=template&id=3e66c43c"
import script from "./contenido.vue?vue&type=script&lang=js"
export * from "./contenido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports